import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(
    private title: Title,
    private meta: Meta
  ) {}

  setCourseSeo(
    courseName: string,
    description: string,
    image: string,
    url: string
  ): void {

    const cleanDescription = this.removeHtml(description);

    // Browser title
    this.title.setTitle(courseName);

    // Standard SEO
    this.meta.updateTag({
      name: 'description',
      content: cleanDescription
    });

    // Open Graph
    this.meta.updateTag({
      property: 'og:title',
      content: courseName
    });

    this.meta.updateTag({
      property: 'og:description',
      content: cleanDescription
    });

    this.meta.updateTag({
      property: 'og:image',
      content: image
    });

    this.meta.updateTag({
      property: 'og:url',
      content: url
    });

    this.meta.updateTag({
      property: 'og:type',
      content: 'website'
    });

    this.meta.updateTag({
      property: 'og:site_name',
      content: 'CamEdu'
    });

    // Twitter
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image'
    });

    this.meta.updateTag({
      name: 'twitter:title',
      content: courseName
    });

    this.meta.updateTag({
      name: 'twitter:description',
      content: cleanDescription
    });

    this.meta.updateTag({
      name: 'twitter:image',
      content: image
    });
  }

  private removeHtml(value: string): string {

    if (!value) {
      return '';
    }

    const div = document.createElement('div');
    div.innerHTML = value;

    return div.textContent || div.innerText || '';
  }
}